/**
 * Created with IntelliJ IDEA.
 * User: omerh
 * Date: 5/7/13
 * Time: 2:14 PM
 * To change this template use File | Settings | File Templates.
 */

define(function (require) {
    "use strict";

    var Marionette = require("marionette");
    var Template = require("templates/personaSwitcherItem.tmpl");
    var CONST = require("const");
    var PersonaSwitcherItemView = Marionette.ItemView.extend({
        template: Template,
        tagName: "div",
        ui: {
            notification: ".notification"
        },
        events: {
            "click": "onClickItem"
        },
        initialize: function (options) {
            this.LE = options.application;
            this.LE.vent.on("onPersonaNotification:notification", function (eventData) {
                this.onNotification(eventData);
            }, this);
            this.model.on("change:displayNotifications", this.onNotificationChanged, this);
            this.$el.addClass(this.model.get("className"));
        },
        setModelData: function (eventData) {
//            var notifications, notificationsTooltip;
//            if(eventData.notificationType === CONST.NOTIFICATIONS.CHAT) {
//                notifications = this.model.get("notifications.chats");
//                notifications += eventData.notifications;
//                this.model.set("notifications.chats", notifications, { silent: true });
//            } else if (eventData.notificationType === CONST.NOTIFICATIONS.ERROR) {
//                notifications = this.model.get("notifications.errors");
//                notifications += eventData.notifications;
//                this.model.set("notifications.errors", notifications, { silent: true });
//            }
//            notificationsTooltip = eventData.notificationsTooltip || "";
            this.model.set("notificationsTooltip", eventData.notificationsTooltip, { silent: true });
            this.model.set("displayNotifications", eventData.notifications);

        },

        setSwitcher: function () {
            if (this.model.get("selected")) {
                this.$el.children().removeClass("on");
                this.$el.removeClass("on");

                this.$el.children().addClass("off");
                this.$el.addClass("off");

                this.$el.toggleClass("on off");
                this.$el.children().toggleClass("on off");
            } else {
                this.$el.children().removeClass("on");
                this.$el.removeClass("on");

                this.$el.children().addClass("off");
                this.$el.addClass("off");
            }
        },
        isSelected: function () {
            return this.$el.children().hasClass("on");
        },
        onNotification: function (eventData) {
            if (this.model.get("type") === eventData.persona) {
                this.setModelData(eventData);
                this.setNotificationDiv();
            }

//            // check if the model match with the persona type we get from the event
//            if (this.model.get("type") === CONST.PERSONA.MARKETER && eventData.persona === CONST.PERSONA.MARKETER) {
//                this.setModelData(eventData);
//                this.setNotificationDiv();
//            }
//            else if (this.model.get("type") === CONST.PERSONA.AGENT && eventData.persona === CONST.PERSONA.AGENT) {
//                this.model.set("selected", this.isSelected());
//                this.setModelData(eventData);
//                this.setNotificationDiv();
//                //this.setSwitcher();
//            }
//
//            // if get at least one error add a class with red background
//            if (this.model.get("notifications.errors") > 0) {
//                this.ui.notification.addClass("backgroundError");
//           }

        },
        setNotificationDiv: function () {
            if (this.model.get("displayNotifications") > 0) {
                this.$el.find(".notification").addClass("notificationOn");
            }
            else {
                this.$el.find(".notification").removeClass("notificationOn");
            }
        },
        onNotificationChanged: function () {
            this.render();
        },
        onClickItem: function () {
            this.LE.vent.trigger("onPersonaSwitcher:onSwitch", {'switchedPersona': this.model.get("type")});
        }
    });
    return PersonaSwitcherItemView;
});
